<template>

  <!-- 1st Hero Variation -->
  <section class="section section_bg mobile_div container-fluid first_page">
    <div class="">

      <div class=" justify-content-center">
        <div  class=" ">


          <loading-block v-if="is_load_projects==false" :loading="!is_load_projects"/>
          <div  v-if="is_load_projects==true">

            <div class="section_header row mobile_div    d-flex justify-content-center">
              <ul class="nav justify-content-center mt-2 mb-2 widget_nav">
                <li class="nav-item" >
                  <a class="nav-link" title="Список" :class="{'active':current_type_list=='list'}" @click="changeTypeList('list')" ><i class="fa fa-list"></i></a>
                </li>
                <li class="nav-item" >
                  <a class="nav-link" title="Канбан" :class="{'active':current_type_list=='canban'}" @click="changeTypeList('canban')"  href="javascript:void(0)"><i class="ni ni-button-pause"></i></a>
                </li>
                <li class="nav-item" >
                  <a class="nav-link" title="Календарь" :class="{'active':current_type_list=='calendar'}" @click="changeTypeList('calendar')"  href="javascript:void(0)"><i class="ni ni-calendar-grid-58"></i></a>
                </li>


              </ul>
            </div>
            <div class="section_header row mobile_div    d-flex justify-content-center " v-if="is_load_projects==true">
              <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center" v-if="user.isdeveloper==1">
                <router-link tag="a" class="btn mt-2" :to="{name: 'add_project'}">
                  Создать <br/>проект <i class="fa fa-plus-circle"></i>
                </router-link>
              </div>
              <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center" v-if="loaded_categorys==true && categorys && categorys.length>0">
                <router-link tag="a" class="btn mt-2" :to="{name: 'freelance_new_request'}">
                  Заказать <br> услугу <i class="fa fa-dollar"></i>
                </router-link>
              </div>


            </div>

            <Canban v-if="current_type_list=='canban'"/>
            <CalendarList v-if="current_type_list=='calendar'"/>
            <div class=""  >

              <div class="section_header mobile_div mt-2 mb-2" v-if="is_load_projects==true && current_type_list=='list'">
              <div class="row d-flex justify-content-center mt-5 mb-5">
                <div class="col-md-10">
                  <input type="text" class="form-control" placeholder="Введите для поиска" @change="changeFilter" v-model="filter.q"/>
                </div>
              </div>
              <div class="row d-flex justify-content-center mt-5 mb-5">
                <div class=" col-md-5 mb-2 ">
                  <select class="form-control" @change="changeFilter" v-model="filter.type">
                    <option value="null">Выберите тип</option>
                    <option value="projects">Проекты</option>
                    <option value="tasks">Задачи</option>
                    <option value="all">Проекты и задачи</option>

                  </select>


                </div>
                <div class="col-md-5">
                  <select class="form-control" @change="changeFilter" v-model="current_status">
                    <option :value="null">Показать все</option>
                    <option v-if="statuses.length>0" v-for="status in statuses" :value="status.last_id"
                        :key="status.last_id">{{
                        status.title
                      }}
                    </option>
                  </select>
                </div>
              </div>
                </div>

              <div class="section_header  mobile_div mt-2 mb-2" v-if="projects.length==0 && current_type_list=='list'">
                <h2 >По вашему запросу ничего не найдено!</h2>
              </div>
              <div class="" v-if="projects.length>0 && current_type_list=='list'">

                <ProjectCard :project="project"
                    v-for="(project,project_index) in projects" :key="project.last_id"/>



                <div class="row mt-2 section_header text-center">
                  <div class="col-6  " >

                    <button v-if=" count>0 && offset>0" @click="prevBtn" class="btn">Назад</button>
                    <button v-if="!( count>0 && offset>0)" disabled   class="btn disabled">Назад</button>
                  </div>

                  <div class="col-6  " >
                    <button @click="nextBtn" v-if="count>next_offset" class="btn">Вперед</button>
                    <button   v-if="!(count>next_offset)" disabled class="btn ">Вперед</button>
                  </div>


                </div>


              </div>

            </div>
          </div>




        </div>
      </div>
<!--      <div class="col-lg-4">-->
<!--        <card type="secondary" shadow-->
<!--              header-classes="bg-white pb-5"-->
<!--              body-classes=""-->
<!--              class="border-0">-->
<!--          <div class="row m-2">-->
<!--            <h3 is="sui-header" dividing>Статистика</h3>-->
<!--          </div>-->
<!--          <div v-if="is_load_chart">-->
<!--            <CircleChart :chartdata="circle_chart.chartdata" :options="circle_chart.options"/>-->
<!--          </div>-->
<!--        </card>-->
<!--      </div>-->
    </div>
  </section>


</template>
<script>

import Canban from "./Canban";
import CalendarList from "@/components/Custom/CalendarList";
import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";

import ProjectCard from "@/components/Custom/ProjectCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import TabPane from "@/components/Tabs/TabPane";
import ListFreelanceRequest from "@/components/Custom/ListFreelanceRequest";
import UserModel from "../../models/UserModel";


export default {
  name: "home",

  data() {

    var app = this;

    return {
      "is_load_projects": false,
      'current_type_list':'list',
      "projects_table": {
        "current_page": 1,
        "on_page": 20,
        "total": 0,
      },
      'activeTab':"work",
      'limit':20,
      'count':0,
      'offset':0,
      'next_offset':0,
      'user':null,
      "filter":{
        "q":"",
        "type":"projects",
      },
      "statuses": {},
      "config": {
        placeholder: 'Распишите задачу как можно подробнее',
        tools: {
          header: require('@editorjs/header'),
          list: {
            class: require('@editorjs/list'),
            inlineToolbar: true,
          },
          "code": require('@editorjs/code'),
          inlineCode: {
            class: require('@editorjs/inline-code'),
            shortcut: 'CMD+SHIFT+M',
          },

          embed: require('@editorjs/embed'),
          linkTool: {
            class: require('@editorjs/link'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/fetchUrl', // Your backend endpoint for url data fetching
            }
          },
          Marker: {
            class: require('@editorjs/marker'),
            shortcut: 'CMD+SHIFT+M',
          },
          table: {
            class: require('@editorjs/table'),
          },
          raw: require('@editorjs/raw'),
          delimiter: require('@editorjs/delimiter'),
          quote: {
            class: require('@editorjs/quote'),
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+O',
            config: {
              quotePlaceholder: 'Enter a quote',
              captionPlaceholder: 'Quote\'s author',
            },
          },
          attaches: {
            class: require('@editorjs/attaches'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/uploadFile?api_token=' + app.$store.getters.TOKEN,
            }
          },
          image: {
            class: require('@editorjs/image'),
            config: {
              additionalRequestHeaders: {
                "Authorization": 'Bearer ' + app.$store.getters.TOKEN
              },
              endpoints: {
                byFile: Vue.config.API_URL + 'editor/uploadImage', // Your backend file uploader endpoint

              }

            }
          },
          warning: require('@editorjs/warning'),
          paragraph: {
            class: require('@editorjs/paragraph'),
            inlineToolbar: true,
          },
          checklist: {
            class: require('@editorjs/checklist'),
            inlineToolbar: true,
          },
        }
      },
      "current_status": null,
      "iserror": false,
      "error_message": null,
      "form": {
        'json': {},
      },
      "loaded_categorys": false,
      "categorys": null,
      "modal_title": "Создать проект",
      'modals': {
        "add": null,
      },
      "projects": [],
      "filter_projects": [],
      'is_load_chart': false,
      'circle_chart': {
        chartdata: {
          labels: ['Ищут исполнителя', 'В работе', 'Завершено',],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#03acca', '#ff3709', '#1aae6f'],
              data: []
            },

          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    }
  },

  mounted: function () {

    var app = this;
    app.getTypeList();
    app.user=UserModel.get();
    if(app.$route.query && app.$route.query.type){
      if(app.$route.query.type=='tasks'){
        app.filter.type='tasks';
      }
    }
    Api.loadStats(function (stats) {


      app.circle_chart.chartdata.datasets[0].data = [stats.freelance, stats.inwork, stats.finish];


      app.is_load_chart = true;
    })




    Api.loadProjectsWithFilterv2(app.limit,app.offset,app.getFilter(),function (data) {
      app.filter_projects = data.projects;
      app.statuses = data.statuses
      app.next_offset=data.offset;
      app.count=data.count;
      app.changeStatusFilter();
      app.projects_table.total = app.project.length;
    });


    Api.loadCategorys(function (data) {
      app.categorys = data;
      app.loaded_categorys = true;
    });


  },
  methods: {
    changeTypeList(type){
      var app=this;
      localStorage.setItem("type_list_projects",type);
      app.current_type_list=type;
    },
    getTypeList(){
      var app=this;
      var result="list";
      if(localStorage.getItem("type_list_projects")){
        result=localStorage.getItem("type_list_projects");
      }
      app.changeTypeList(result);
      return result;
    },

    onTabChange(tab_active){
      this.activeTab=tab_active;
    },
    getFilter(){
      var app=this;
      var filter={};
      if(Number.isInteger(app.current_status)){
        filter.status=app.current_status;
      }
      filter.type=app.filter.type;
      filter.q=app.filter.q;

      return filter;
    },
    callModalAddProject() {
      eventBus.$emit("call_modal_add_project", {add_project:true})
      {

      }
    },
    changeFilter(){

      var app = this;
      app.is_load_projects=false;
      var filter={};
      if(Number.isInteger(app.current_status)){
        filter.status=app.current_status;
      }
      filter.type=app.filter.type;
      filter.q=app.filter.q;
      app.offset=0;

      Api.loadProjectsWithFilterv2(app.limit,app.offset,filter,function (data) {
        app.filter_projects = data.projects;
        app.next_offset=data.offset;
        app.statuses = data.statuses
        app.is_load_projects=true;
        app.count=data.count;
        app.next_offset=data.offset;
        app.changeStatusFilter();
        app.projects_table.total = app.project.length;
      });

    },
    changeStatusFilter() {
      var app = this;
      var projects = [];
      if (Number.isInteger(app.current_status)) {
        app.projects_table.total = 0;
        var total = 0;
        app.filter_projects.forEach(function callback(currentValue, index, array) {
          //your iterator
          if (currentValue.status == app.current_status) {
            projects.push(currentValue);

          }
        });
        app.projects = projects;
      } else {
        app.projects = app.filter_projects;
      }

      app.projects_table.total = app.projects.length;
      app.is_load_projects = true;
    },
    prevBtn(){
      var app=this;
      app.is_load_projects=false;
      var offset=app.offset;
      offset=offset-app.limit;

      if(offset>=0){
        Api.loadProjectsWithFilterv2(app.limit,offset,app.getFilter(),function (data) {
          app.filter_projects=null;
          app.filter_projects = data.projects;
          app.offset=offset;
          app.next_offset=data.offset;
          app.statuses = data.statuses
          app.changeStatusFilter();
          app.is_load_projects=true;
          app.projects_table.total = app.project.length;
        });
      }
    },
    nextBtn(){

      var app=this;
      app.is_load_projects=false;
      if(app.next_offset>app.offset){
        Api.loadProjectsWithFilterv2(app.limit,app.next_offset,app.getFilter(),function (data) {
          app.filter_projects=null;
          app.filter_projects = data.projects;
          app.offset=app.next_offset;
          app.next_offset=data.offset;
          app.statuses = data.statuses
          app.changeStatusFilter();
          app.is_load_projects=true;
          app.projects_table.total = app.project.length;
        });
      }
    },
    invokeSave() {
      var app = this;

      this.$refs.editor._data.state.editor.save()
          .then((data) => {
            // Do what you want with the data here

            var app = this;
            var newTask = app.form;
            newTask.json = data;
            Api.createProject(newTask, function (result) {
              if (result.iserror == false) {
                app.iserror = false;
                app.modals.add = false;
                app.form = {};
                app.$refs.editor._data.state.editor.clear();
                app.is_load_projects = false;
                Api.loadProjects(function (data) {
                  app.projects = data.projects;
                  app.is_load_projects = true;
                });
              } else {
                app.iserror = true;
                app.error_message = result.error_message;
              }
            });



          })
          .catch(err => {

          })
    },
    addProject() {
      this.$refs.editor._data.state.editor.render({
        "blocks": [
          {
            "type": "header",
            "data": {
              "text": "Название вашего замечательного проекта!",
              "level": 2
            }
          },
          {
            "type": "paragraph",
            "data": {
              "text": "Здесь могут быть описано базовое описание вашего проекта. а также разных требований например:",
            }
          },
          {
            "type": "list",
            "data": {
              "style": "unordered",
              "items": [
                "Знать Laravel",
                "Уметь работать с Vue.js",
                "Уметь работать с REST API"
              ]
            }
          }
        ]
      });
      this.form.category = null;

      this.modal_title = "Создание проекта";
      this.modals.add = true;


    },

  },
  components: {CalendarList,Canban,ListFreelanceRequest, Modal,"ProjectCard":ProjectCard,LoadingBlock,Tabs,Tab,TabPane,}
};
</script>